import type { TableConfig } from '../types'

function pivotData<T extends Record<string, unknown>>({
  columns,
  data,
  pivot,
}: Pick<TableConfig<T>, 'columns' | 'data' | 'pivot'>) {
  const result = [] as Array<Array<T[Extract<keyof T, string>]>>
  if (!pivot) {
    for (let i = 0; i < columns.length; i++) {
      const column = columns[i]!
      result.push([] as T[Extract<keyof T, string>][])
      for (let j = 0; j < data.length; j++) {
        const row = data[j]!
        result[j]![i] = row[column.field]
      }
    }
    return result
  }
  for (let i = 0; i < data.length; i++) {
    const row = data[i]!
    result.push([] as T[Extract<keyof T, string>][])
    for (let j = 0; j < columns.length; j++) {
      const column = columns[j]!
      result[j]![i] = row[column.field]
    }
  }
  return result
}

export default pivotData
